import React, { FC } from 'react'
import { cn } from 'shared/utils'

import { ArtistAvatar } from 'components'
import { FollowButton } from 'modulesCommon/Follow/containers'

import { IArtistMainInfo } from './ArtistMainInfo.props'
import './ArtistMainInfo.scss'
import GpsBadge from '../../../../components/GpsBadge/GpsBadge'

const ArtistMainInfo: FC<IArtistMainInfo> = ({ artist, project, offset = true }) => {
  const gpsStatus = artist?.gps_status
  return (
    <div className={cn('artist-header', { 'artist-header--offset': offset })}>
      <ArtistAvatar
        spotifyId={artist.spotify_id}
        facebookId={artist.facebook_id}
        size="m"
        className="artist-header__avatar"
      />
      <div className="artist-header-detail">
        <h2 className="artist-header-detail__name">{artist.name} {gpsStatus && (<GpsBadge gpsStatus={gpsStatus} coloredBackground className={'artist-header-detail__gps-badge'} />)}</h2>
        <h3 className="artist-header-detail__project-name">{project.name}</h3>
      </div>
      <div className="artist-header__btn">
        <FollowButton userId={project?.owner_id} projectId={project?.id} projectName={project?.name} />
      </div>
    </div>
  )
}

export default ArtistMainInfo
